export const pxToRem = (px: number): string => {
  return `${px / 14}rem`;
};
